import App from 'app/app.js';
import 'app/directive/LtSelectSheetDrawerCtrl.js';

function LtSelectSheetDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onSelectItem: '&',
      onCancel: '&',
      sheets: '='
    },
    template:
      '<div class="look-selection-drawer bottom-drawer bottom-drawer-alignment" lt-drawer="selectSheetDrawer.visible"' +
      '    ng-init="selectSheetDrawer.init()" lt-drawer-cancellation="">' +
      '        <div class="row">' +
      '          <h4>' +
      '              <span data-id="button" class="pull-right cursor-pointer modal-close gray cyop-close" ng-click="selectSheetDrawer.onClose()"><span lt-translate="ADD_ON_CLOSE_WITH_ICON"></span><lt-icon name="fa-sharp-solid-times"></lt-icon></span>' +
      '           </h4>' +
      '        </div>' +
      '        <div class="row">' +
      '          <h4 class="cyop-header-wrap">' +
      '              <span class="cyop-header" lt-translate="CYOP_CHOOSE_YOUR_ITEM"></span>' +
      '           </h4>' +
      '        </div>' +
      '        <hr class="cyop-underline">' +
      '        <div class="zoomed">' +
      '        <div class="modal-content">' +
      '            <div id="portrait-sheet-cont">' +
      '                <lt-addon-carousel addons="sheets" confirm="selectSheetDrawer.selectItem(selectedItem)"></lt-addon-carousel>' +
      '            </div>' +
      '        </div>' +
      '    </div>' +
      '</div>',
    controller: 'LtSelectSheetDrawerCtrl',
    controllerAs: 'selectSheetDrawer'
  };
}

App.directive('ltSelectSheetDrawer', [LtSelectSheetDrawerDirective]);
